<div aria-labelledby="contact-tab" class="tab-pane fade" id="day5" role="tabpanel">
    <div class="container-fluid">
        <div class="error-list" v-if="ui.error.error_message">
            <ul class="error-msg">
                <li :key="x" v-for="(error,x) in ui.error.error_message">
                    <div :key="i" v-for="(err,i) in error">
                        <p> {{err}}</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="content-block">
            <FlashMessage></FlashMessage>
            <form>
                <div class="form-modified">
                    <div class="empty-data green">
                        <p>
                            Reservation notification for hotel.
                        </p>
                    </div>

                    <div class="form-group row">
                        <label for="staticEmail" class="col-sm-2 col-form-label">Free cancel<span class="required">*</span></label>
                        <div class="col-sm-10">
                            <div v-if="!ui.status.canEdit">
                                <label v-if="item.reservationData.is_free_cancel==1" class="readonly">Yes</label>
                                <label v-if="item.reservationData.is_free_cancel==0" class="readonly">No</label>
                            </div>
                            <div v-if="ui.status.canEdit">
                                <label class="customcheck">{{ item.reservationData.is_free_cancel==1?'Yes':'No' }}
                                    <input type="checkbox" name="is_free_cancel" value="1" class="destination" v-model="item.reservationData.is_free_cancel"/>
                                         <span class="checkmark"></span>
                                       </label> </div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="staticEmail" class="col-sm-2 col-form-label">Reservation Without Credit Card<span class="required">*</span></label>
                        <div class="col-sm-10">
                            <div v-if="!ui.status.canEdit">
                                <label v-if="item.reservationData.is_reservation_without_creadit_card==1" class="readonly">Yes</label>
                                <label v-if="item.reservationData.is_reservation_without_creadit_card==0" class="readonly">No</label>
                            </div>
                            <div v-if="ui.status.canEdit">
                                <label class="customcheck">{{ item.reservationData.is_reservation_without_creadit_card==1?'Yes':'No' }}
                                    <input type="checkbox" name="is_reservation_without_creadit_card" value="1" class="destination" v-model="item.reservationData.is_reservation_without_creadit_card"/>
                                         <span class="checkmark"></span>
                                       </label> </div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="staticEmail" class="col-sm-2 col-form-label">Pre-Payment<span class="required">*</span></label>
                        <div class="col-sm-10">
                            <div v-if="!ui.status.canEdit">
                                <label v-if="item.reservationData.is_no_prepayment==1" class="readonly">Yes</label>
                                <label v-if="item.reservationData.is_no_prepayment==0" class="readonly">No</label>
                            </div>
                            <div v-if="ui.status.canEdit">
                                <label class="customcheck">{{ item.reservationData.is_no_prepayment==1?'Yes':'No' }}
                                    <input type="checkbox" name="is_no_prepayment" value="1" class="destination" v-model="item.reservationData.is_no_prepayment"/>
                                         <span class="checkmark"></span>
                                       </label> </div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="staticEmail" class="col-sm-2 col-form-label">Exchange Currency<span class="required">*</span></label>
                        <div class="col-sm-10">
                            <div v-if="!ui.status.canEdit">
                                <label v-if="item.reservationData.can_exchange_currency==1" class="readonly">Yes</label>
                                <label v-if="item.reservationData.can_exchange_currency==0" class="readonly">No</label>
                            </div>
                            <div v-if="ui.status.canEdit">
                                <label class="customcheck">{{ item.reservationData.can_exchange_currency==1?'Yes':'No' }}
                                    <input type="checkbox" name="can_exchange_currency" value="1" class="destination" v-model="item.reservationData.can_exchange_currency"/>
                                         <span class="checkmark"></span>
                                       </label> </div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label" for="staticEmail">
                            Currency</label>
                        <div class="col-sm-10">
                            <label class="readonly" for="staticEmail" v-if="!ui.status.canEdit">{{item.reservationData.currency}}</label>
                            <input class="form-control" :class="{ 'error-input' : ui.error.errors['currency'] }" id="" name="" placeholder="currency" v-if="ui.status.canEdit" v-model="item.reservationData.currency"></input>
                            <validation-error :errors="ui.error.errors" :field="'currency'" :isError="ui.error.has_error" v-if="ui.error.has_error" />
                        </div>
                    </div>


                    <div class="form-group row">

                        <label class="col-sm-2 col-form-label" for="staticEmail">
                            Time Zone</label>
                        <div class="col-sm-10">
                            <label class="readonly" for="staticEmail" v-if="!ui.status.canEdit">{{item.reservationData.timezone}}</label>
                            <input class="form-control" :class="{ 'error-input' : ui.error.errors['timezone'] }" id="" name="" placeholder="eg.GMT+5:45" v-if="ui.status.canEdit" v-model="item.reservationData.timezone"></input>
                            <validation-error :errors="ui.error.errors" :field="'timezone'" :isError="ui.error.has_error" v-if="ui.error.has_error" />
                        </div>
                    </div>

                    <div class="content-block">
                        <div class="row">
                            <div class="col-md-10 offset-md-2">
                                <button @click.prevent="onEditReservationClick" class="btn default-btn" type="submit" v-if="!ui.status.canEdit">
                                    Edit
                                </button>
                                <button @click.prevent="createReservation" class="btn default-btn save-btn" type="submit" v-if="ui.status.canEdit">{{buttonName}}
                                    <spinner :loading="ui.status.postLoading.addReservation" v-if="ui.status.postLoading.addReservation"></spinner>
                                </button>
                                <button @click.prevent="cancelReservation" class="btn default-btn cancel" type="submit" v-if="ui.status.canEdit" :disabled="ui.status.postLoading.addReservation">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>